import request from "@/api/request";

export default {
    // 积分兑换优惠券
    couponList: async data => request({url: '/console/basic.Common/couponList', data}),
}
